var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripBubble = function SvgStripBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.827 0H20.26c1.313 0 2.508.538 3.375 1.405a4.771 4.771 0 011.407 3.378v8.952a4.765 4.765 0 01-1.405 3.375 4.77 4.77 0 01-3.378 1.407h-8.53l-6.274 4.63a.687.687 0 01-1.066-.743l1.133-3.886h-.698a4.765 4.765 0 01-3.375-1.405 4.77 4.77 0 01-1.407-3.378V4.783c0-1.314.538-2.509 1.405-3.376A4.77 4.77 0 014.825 0h.002z",
    clipPath: "url(#clip0_2492_14291)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2492_14291"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v24H0z"
  })))));
};
export default SvgStripBubble;